export default {
  path: "/SectionContent/Overview",
  name: "Overview",
  htmlContent: "overview.html",
  headings: [],
};
